export default {
  state: {
    globalAlert: {
      show: false,
      message: '',
      color: '',
      timeout: 6000
    },
    globalLoader: {
      show: false,
      message: '',
      color: ''
    }
  },
  getters: {
    globalAlert: state => state.globalAlert,
    globalLoader: state => state.globalLoader
  },
  mutations: {
    showGlobalAlert: (state, {
      value,
      message,
      color
    }) => {
      if (color != null) {
        state.globalAlert.color = color
      } else {
        state.globalAlert.color = 'success'
      }
      state.globalAlert.message = message
      state.globalAlert.show = value
    },
    showGlobalLoader: (state, {
      value,
      message,
      color
    }) => {
      if (color != null) {
        state.globalLoader.color = color
      } else {
        state.globalLoader.color = 'success'
      }
      state.globalLoader.message = message
      state.globalLoader.show = value
    }
  }
}